import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { IconEnum } from 'shared/design-system/data-access/icon';
import { PxSize, RemSize } from 'shared/design-system/data-access/layout';
import { ColorEnum } from 'shared/design-system/data-access/theme';

@Component({
    selector: 'it-icon',
    imports: [TooltipModule, NgStyle, NgClass],
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
    @Input({ required: true }) icon!: IconEnum;
    @Input() tooltip?: string;
    @Input() color?: ColorEnum;
    @Input() fontSize?: RemSize;
    @Input() spin?: boolean;
    @Input() backgroundColor?: ColorEnum;
    @Input() height?: PxSize | RemSize;
    @Input() width?: PxSize | RemSize;
    @Input() borderRadius?: PxSize;
    @Input() alignContent?: 'center' | 'end' | 'start';
    @Input() textAlign?: 'center' | 'end' | 'start';

    get style() {
        return {
            color: this.color ?? 'inherit',
            fontSize: this.fontSize,
            background: this.backgroundColor,
            height: this.height,
            width: this.width,
            borderRadius: this.borderRadius,
            alignContent: this.alignContent,
            textAlign: this.textAlign,
        };
    }
}
